import {createAsyncThunk} from '@reduxjs/toolkit'
import {YandexService} from 'services/yandexSDK'
import {RootState} from '../index'
import {NO_ERROR_MESSAGE} from '../handler'
import {setEntries} from './slice'

export const getEntriesThunk = createAsyncThunk<void, undefined, {rejectValue: string; state: RootState}>(
  'topcup/getEntriesThunk',
  async (_, thunkAPI) => {
    try {
      const data = await YandexService.getLeaderBoardEntries()
      thunkAPI.dispatch(setEntries(data ?? []))
    } catch (error) {
      if (error instanceof Error) {
        return thunkAPI.rejectWithValue(error.message)
      }
      return thunkAPI.rejectWithValue(NO_ERROR_MESSAGE)
    }
  }
)
